import { useState } from 'react'
import { useSnackbar } from '@ui/snackbar'
import useIsAnyCheckSettingsSectionBlocked from './useIsAnyCheckSettingsSectionBlocked'

interface Result {
  isExpanded: boolean
  handleToggleExpanded: () => void
}

const UNSAVED_CHANGES_WARNING =
  'Bitte speichern oder verwerfen Sie die Nachweiseinstellungen, bevor Sie fortfahren'

/**
 * Guards the check settings section's own collapse toggle while any tab has
 * unsaved edits, refusing to collapse (and warning instead) the same way
 * switching tabs already does.
 */
const useCheckSettingsSection = (): Result => {
  const { enqueueSnackbar } = useSnackbar()
  const isBlocked = useIsAnyCheckSettingsSectionBlocked()

  const [isExpanded, setIsExpanded] = useState(true)

  const handleToggleExpanded = (): void => {
    if (isExpanded && isBlocked) {
      enqueueSnackbar(UNSAVED_CHANGES_WARNING, { variant: 'warning' })
      return
    }
    setIsExpanded(previous => !previous)
  }

  return { isExpanded, handleToggleExpanded }
}

export default useCheckSettingsSection
